export default "__VITE_ASSET__PRw$Ow$k__"